import noUiSlider from "nouislider";
import resize from "./resize";

const initRange = () => {
  const range = document.querySelector(".range__wrapper");
  if (!range) return;
  const totalPrice = document.querySelector("[data-total-price]");
  const calcDisplay = document.querySelector(".calc_display");
  const minusButton = document.querySelector("[data-minus]");
  const plusButton = document.querySelector("[data-plus]");

  const rangeOptions = {
    start: 20000,
    step: 5000,
    tooltips: {
      to: (value) => value + ' руб '
    },
    format: {
      to: (value) => {
        if (Number.isInteger(value)) {
          return value.toFixed(0);
        };
        return value.toFixed(1);
      },
      from: (value) => {
        return parseFloat(value);
      },
    },
    range: {
      "min": [20000],
      "max": [150000],
    },
  }

  const init = () => {    
    if (window.innerWidth < 768) {
      if (range.noUiSlider) {
        let currentRangeValue = +range.noUiSlider.get();
        range.noUiSlider.destroy();
        noUiSlider.create(range, {
          ...rangeOptions,
          orientation: 'vertical',
          direction: 'rtl',
          start: currentRangeValue
        });
      } else {
        noUiSlider.create(range, {
          ...rangeOptions,
          orientation: 'vertical',
          direction: 'rtl',
        });
      }
    } else {
      if (range.noUiSlider) {
        let currentRangeValue = +range.noUiSlider.get();
        range.noUiSlider.destroy();
        noUiSlider.create(range, {
          ...rangeOptions,
          orientation: 'horizontal',
          start: currentRangeValue
        });
      } else {
        noUiSlider.create(range, {
          ...rangeOptions,
          orientation: 'horizontal'
        });
      }
    }

    range.noUiSlider.on('update', (values, handle) => totalPrice.textContent = values[handle] * 0.15 * +calcDisplay.value);
  }

  minusButton.addEventListener("click", () => {
    let currentValue = +calcDisplay.value - 1;
    if (currentValue >= 1) {
      calcDisplay.value = currentValue;
    }
    totalPrice.textContent = +range.noUiSlider.get() * 0.15 * +calcDisplay.value
  })

  plusButton.addEventListener("click", () => {
    let currentValue = +calcDisplay.value + 1;
    if (currentValue <= 100) {
      calcDisplay.value = currentValue;
    }
    totalPrice.textContent = +range.noUiSlider.get() * 0.15 * +calcDisplay.value
  });

  calcDisplay.addEventListener("input", (evt) => {
    if (evt.target.value < 1) {
      calcDisplay.value = 1;
    } else if (evt.target.value > 100) {
      calcDisplay.value = 100;
    } else {
      calcDisplay.value = evt.target.value;
    }
    totalPrice.textContent = +range.noUiSlider.get() * 0.15 * +calcDisplay.value
  })

  init();
  resize(init);
};

export default initRange;
